import { Quote } from "lucide-react";

const items = [
  {
    quote:
      "The market was brutal - JobNex still landed me 8+ interviews every week. In a recession, that's not normal. Insane.",
    badge: "8+ interviews/week · even in a recession",
    initials: "PS",
    photo: "/testimonials/aarav-hero-indian.jpg?v=4",
    photoPosition: "center 20%",
    name: "Prasanjay S.",
    role: "Software Engineer",
    tid: "testimonial-1",
  },
  {
    quote:
      "The part that sold me was the call - they'd already read my GitHub and knew my projects better than most interviewers. It never felt like a service. It felt like someone in my corner.",
    badge: "3 offers · placed in 6 weeks",
    badgeHidden: true,
    initials: "PK",
    photo: "/testimonials/priya-hero-indian.jpg?v=1",
    photoPosition: "center 20%",
    name: "Priya K.",
    role: "Backend Engineer",
    tid: "testimonial-2",
  },
  {
    quote:
      "I was skeptical about paying upfront. But I kept applying on my own in parallel and still got nothing - every interview that mattered came from them. The fee paid for itself in my first month.",
    badge: "₹18L → ₹32L · placed in 7 weeks",
    badgeHidden: true,
    initials: "RM",
    photo: "/testimonials/rohan-hero-indian.jpg?v=2",
    photoPosition: "center 18%",
    name: "Rohan M.",
    role: "Full-Stack Engineer (Node)",
    tid: "testimonial-3",
  },
  {
    quote:
      "What I didn't expect was the prep before each round and the debrief after. By my third interview I knew exactly what to lead with. That's the difference between getting seen and getting hired.",
    badge: "2 offers · placed in 4 weeks",
    badgeHidden: true,
    initials: "SN",
    photo: "/testimonials/sneha-hero-indian.jpg?v=1",
    photoPosition: "center 20%",
    name: "Sneha N.",
    role: "Data Engineer",
    tid: "testimonial-4",
  },
];

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="max-w-3xl mb-16">
          <p className="label-eyebrow text-[#143628] mb-5">Testimonials</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05] tracking-tight">
            Words from people who <em className="italic text-[#143628]">got placed.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {items.map((t) => (
            <figure
              key={t.tid}
              data-testid={t.tid}
              className="relative bg-white border border-[#1C1C1A]/10 p-8 sm:p-10 hover:border-[#143628]/30 transition-colors flex flex-col"
            >
              <Quote className="absolute top-6 right-6 h-8 w-8 text-[#D4B886]/40" />

              {t.badge && (
                <span
                  data-testid={`${t.tid}-badge`}
                  className={`self-start label-eyebrow text-[#143628] bg-[#F0EFEB] px-3 py-1.5 border border-[#143628]/15 mb-6${t.badgeHidden ? " hidden" : ""}`}
                >
                  {t.badge}
                </span>
              )}

              <blockquote className="font-serif-display text-2xl sm:text-[28px] leading-[1.25] text-[#1C1C1A] flex-grow">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              <figcaption className="mt-8 pt-6 border-t border-[#1C1C1A]/10 flex items-center gap-4">
                <span
                  data-testid={`${t.tid}-avatar`}
                  className="relative flex h-12 w-12 items-center justify-center bg-[#143628] text-[#D4B886] font-serif-display text-lg tracking-wide rounded-full flex-shrink-0 overflow-hidden ring-1 ring-[#143628]/20"
                >
                  <img
                    src={t.photo}
                    alt={t.name}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover"
                    style={t.photoPosition ? { objectPosition: t.photoPosition } : undefined}
                  />
                  <span aria-hidden="true" className="opacity-0">{t.initials}</span>
                </span>
                <div>
                  <p className="font-medium text-[#1C1C1A]">{t.name}</p>
                  <p className="text-sm text-[#4A4A48] mt-0.5">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
